"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartsuppTranslationsClientApi = void 0;
const translations_1 = require("./apis/translations");
class SmartsuppTranslationsClientApi {
    constructor(adapter) {
        this.adapter = adapter;
        this.translations = new translations_1.TranslationsClient(adapter);
    }
    withOptions(o) {
        return new SmartsuppTranslationsClientApi(this.adapter.withOptions(o));
    }
}
exports.SmartsuppTranslationsClientApi = SmartsuppTranslationsClientApi;
exports.default = SmartsuppTranslationsClientApi;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxzREFBd0Q7QUFFeEQsTUFBYSw4QkFBOEI7SUFHMUMsWUFBbUIsT0FBdUI7UUFBdkIsWUFBTyxHQUFQLE9BQU8sQ0FBZ0I7UUFDekMsSUFBSSxDQUFDLFlBQVksR0FBRyxJQUFJLGlDQUFrQixDQUFDLE9BQU8sQ0FBQyxDQUFBO0lBQ3BELENBQUM7SUFFRCxXQUFXLENBQUMsQ0FBSTtRQUNmLE9BQU8sSUFBSSw4QkFBOEIsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBQ3ZFLENBQUM7Q0FDRDtBQVZELHdFQVVDO0FBRUQsa0JBQWUsOEJBQThCLENBQUEifQ==